<ng-container>
  <div class="text-format-body" [innerHTML]="text | safeHtml"></div>
</ng-container>


